module.exports = __webpack_public_path__ + "img/coverPhoto.4ed9ff2b.jpeg";